import styled from "styled-components";
import { Box, Flex, Image } from "rebass/styled-components";

export const Card = styled(Box)`
  background: ${({ theme }) => theme.colors.grey850};
  border-radius: 12px;
  padding: 24px;
`;

export const TimePill = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.grey850};
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.colors.navy};
  font-weight: 500;
  justify-content: center;
  padding: 8px;
`;

export const StyledMomentIcon = styled(Image)<{ shouldFlipImage?: boolean }>`
  flex: 1 1 28px;
  height: 18px;
  max-width: 100%;
  transform: ${(props) => props.shouldFlipImage && "scaleX(-1)"};
  filter: brightness(0) saturate(100%) invert(73%) sepia(9%) saturate(590%)
    hue-rotate(144deg) brightness(90%) contrast(86%);
`;
